import React, { useEffect } from "react";
import ReactModal from "react-modal";
// import useClickOutside from "./use-click-outside";
import { useLocation } from "@reach/router";
// import ModalSearch from "./modal-search";
// import ModalMain from "./modal-main";
import { FiFacebook } from "react-icons/fi";
import { FiYoutube } from "react-icons/fi";
import { FaXTwitter } from "react-icons/fa6";
import { FaInstagram } from "react-icons/fa6";

import { Link } from "gatsby";

const ModalMenu = ({
  showModal,
  handleCloseModal
}) => {

  const location = useLocation();

  useEffect(() => {
    handleCloseModal();
  }, [location]);

  useEffect(() => {
    ReactModal.setAppElement(document.getElementById("gatsby-focus-wrapper"));
  }, []);
  
  return (
    <ReactModal
    
      shouldCloseOnOverlayClick={true}
      isOpen={showModal}
      className={`menu-modal`}
      contentLabel={
        "Main Navigation modal"
        /* String indicating how the content container should be announced
                 to screenreaders */
      }
      onRequestClose={handleCloseModal}
      style={{
        overlay: {
          backgroundColor: "var(--color-menu-background)",
        },
      }}
      preventScroll={true}
    >
      {/* <div className={`modal-wrapper menu`}> */}
      {/* <section className="modal-header"> */}
      <nav className="modal-nav">
        <ul className="primary-menu">
          <li>
            <Link to="/category/analysis/">Analysis</Link>
          </li>
          <li>
            <Link to="/category/stories/" className="underline-onhover">
              Stories
            </Link>
          </li>

          <li>
            <Link to="/category/op-eds/" className="underline-onhover">
              Op-Eds
            </Link>
          </li>
          <li>
            <Link to="/category/webinars/" className="underline-onhover">
              Webinars
            </Link>
          </li>
          <li>
            <Link to="/category/publications/" className="underline-onhover">
              Publications
            </Link>
          </li>
          <li>
            <Link to="/authors" className="underline-onhover">
              Authors
            </Link>
          </li>
          <li>
            <Link to="/archive" className="underline-onhover">
              Archive
            </Link>
          </li>
          <li>
            <Link to="/category/anouncements/" className="underline-onhover">
            Anouncements
            </Link>
          </li>
        </ul>
      </nav>

      <ul className="social">
        <li className="with-icons">
          <a
            aria-label="youtube link"
            href="https://www.youtube.com/@caucasusedition304"
          >
            <FiYoutube />
          </a>
        </li>
        <li className="with-icons">
          <a
            aria-label="facebook link"
            href="https://www.facebook.com/journalofconflicttransformation"
          >
            <FiFacebook />
          </a>
        </li>
        <li className="with-icons">
          <a aria-label="twitter link" href="https://x.com/CaucasusEdition">
            <FaXTwitter />
          </a>
        </li>
        <li className="with-icons">
          <a
            aria-label="instagramm link"
            href="https://www.instagram.com/caucasusedition"
          >
            <FaInstagram />
          </a>
        </li>
      </ul>
      {/* </section> */}
      {/* <section className="modal-content"> */}
      <ul className="credentials">
        <li>
          <Link
            className="underline-onhover"
            activeClassName="active"
            partiallyActive={true}
            to="/code-of-ethics/"
          >
            Code of Ethics
          </Link>
        </li>
        <li>
          <Link
            className="underline-onhover"
            activeClassName="active"
            partiallyActive={true}
            to="/glossary-and-guidelines/"
          >
            Glossary and Guidelines
          </Link>
        </li>
        <li>
          <Link
            className="underline-onhover"
            activeClassName="active"
            partiallyActive={true}
            to="/citation-guidelines-for-authors-and-editors/"
          >
            Citation Guidelines
          </Link>
        </li>
        <li>
          <Link
            className="underline-onhover"
            activeClassName="active"
            partiallyActive={true}
            to="/for-contributors/"
          >
            For Contributors
          </Link>
        </li>
          <li>
            <Link
              activeClassName="active"
              className="underline-onhover"
              partiallyActive={true}
              to="/contact-us/"
            >
              Contact Us
            </Link>
          </li>
        <li>
          <Link
            className="underline-onhover"
            activeClassName="active"
            partiallyActive={true}
            to="/about-us/"
          >
            About Us
          </Link>
        </li>
      </ul>
      {/* </section> */}
      {/* </div> */}
      {/* <div className="close"> */}
      <button
        aria-label="close modal window"
        className="with-icons close-modal"
        onClick={() => handleCloseModal()}
      >
        🗙
      </button>
      {/* </div> */}
    </ReactModal>
  );
};

export default ModalMenu;
